import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// -----------------------------------------------------------

Logo.propTypes = {
	disabledLink: PropTypes.bool,
	sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
	const theme = useTheme();
	const PRIMARY_LIGHT = theme.palette.primary.light;
	const PRIMARY_MAIN = theme.palette.primary.main;
	const PRIMARY_DARK = theme.palette.primary.dark;
	const logo = (
		<Box sx={{ width: 40, height: 40, ...sx }}>
			<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 715.000000 540.000000">
				<defs>
					<linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
						<stop offset="0%" stopColor={PRIMARY_DARK} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
					<linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
						<stop offset="0%" stopColor={PRIMARY_LIGHT} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
					<linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
						<stop offset="0%" stopColor={PRIMARY_LIGHT} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
				</defs>
				<g
					fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,540.000000) scale(0.100000,-0.100000)" >
				<path d="M2430 4906 c-264 -60 -440 -295 -501 -666 -25 -159 -35 -300 -30
-462 1 -15 11 -18 61 -18 69 0 62 -12 80 147 26 241 124 410 278 481 50 23 70
26 167 26 101 1 115 -2 170 -29 77 -37 157 -113 205 -195 66 -111 144 -322
196 -525 13 -55 29 -116 35 -135 24 -87 86 -386 134 -650 9 -47 22 -116 30
-155 8 -38 22 -113 31 -165 9 -52 22 -126 29 -165 24 -126 45 -249 55 -320 6
-38 15 -96 20 -128 8 -55 7 -63 -27 -135 -66 -145 -81 -177 -101 -227 -168
-412 -252 -762 -252 -1049 0 -202 51 -328 154 -381 37 -19 65 -25 111 -25 164
0 267 131 329 420 22 103 46 396 46 560 0 156 -26 596 -40 686 -20 124 -18
135 86 350 52 109 104 217 114 239 10 22 59 125 109 228 50 104 91 190 91 192
0 2 42 90 94 197 51 106 103 213 114 238 11 25 61 130 111 233 50 104 91 190
91 192 0 1 40 85 89 186 48 101 106 222 129 269 58 125 252 530 306 640 25 52
46 98 46 103 0 4 -163 6 -362 5 l-361 -3 -28 -95 c-15 -52 -48 -167 -74 -255
-101 -348 -115 -393 -139 -480 -14 -49 -30 -103 -35 -120 -5 -16 -42 -140 -81
-275 -39 -135 -79 -274 -90 -310 -35 -118 -127 -432 -170 -580 -23 -80 -51
-176 -63 -215 l-20 -70 -9 35 c-4 19 -15 85 -23 145 -42 317 -84 587 -140 900
-134 743 -253 1071 -451 1242 -62 54 -174 110 -243 123 -72 13 -203 11 -271
-4z"/>

</g>
</svg>


		</Box >
	);
	if (disabledLink) {
		return <>{logo}</>;
	}

	return <RouterLink to="">{logo}</RouterLink>;
}
